var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex flex-col px-2"},[(_vm.streamId !== null)?_c('vue-disqus',{attrs:{"shortname":"live-storm-chasing","identifier":_vm.streamId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }